import { LwFormMultiSelect } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { Chip, createFilterOptions, styled } from '@mui/material';
import { useCallback } from 'react';
import { BusinessUnitsFilterFormContext } from '../business-units/filter-business-units.types';

type BusinessUnitOption = {
  value: string;
  label: string;
  branchOfficeName?: string;
};

interface FilterBusinessUnitsSelectProps {
  formName:
    | 'branchOffices'
    | 'departments'
    | 'businessUnitCheckboxValue'
    | `branchOffices.${number}`
    | `branchOffices.${number}.value`
    | `branchOffices.${number}.label`
    | `departments.${number}`
    | `departments.${number}.value`
    | `departments.${number}.label`;
  options: BusinessUnitOption[];
  disabled?: boolean;
  label: string;
  onChange?: (value: BusinessUnitOption[]) => void;
}

export const FilterBusinessUnitsSelect = (props: FilterBusinessUnitsSelectProps) => {
  const { control } = useFormContext<BusinessUnitsFilterFormContext>();

  const { formName, label, options, disabled } = props;

  const filterOptions = useCallback(
    createFilterOptions({
      stringify: ({ label, branchOfficeName }: BusinessUnitOption) =>
        `${label} ${branchOfficeName ?? ''}`,
    }),
    []
  );

  return (
    <LwFormMultiSelect
      name={formName}
      control={control}
      options={options}
      disabled={disabled}
      label={label}
      ariaLabelInput={label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) =>
        option.branchOfficeName ? `${option.label} (${option.branchOfficeName})` : option.label
      }
      renderOption={(props, option) => (
        <Option {...props} key={option.value} hasDescription={!!option.branchOfficeName}>
          <Chip label={option.label} />
          {option.branchOfficeName ? option.branchOfficeName : null}
        </Option>
      )}
      filterOptions={filterOptions}
      data-testid="filter-business-units-select"
    />
  );
};

const Option = styled('li')<{
  hasDescription: boolean;
}>(({ theme, hasDescription }) => ({
  display: 'flex',
  '.MuiChip-root': {
    backgroundColor: theme.palette.lwPrimary[10],
    marginBottom: 0,
    borderRadius: theme.spacing(6),
    maxWidth: hasDescription ? '50%' : '100%',
    height: 'auto',
    whiteSpace: 'normal',
  },
  '.MuiChip-label': {
    color: theme.palette.lwPrimary[100],
    width: 'auto',
    height: 'auto',
    whiteSpace: 'normal',
    overflow: 'visible',
  },
}));
